import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneNumberLink } from '../PhoneNumberLink';
import { defaultLink } from './defaultLink';
import { navigationLink } from './navigationLink';
import { smallMargin, mediumMargin, gutter } from '../../margins';
import { minWidth, tablet } from '../../screenSizes';

export const Navigation = ({ phoneNumber, posts }) => (
  <div
    css={`
      padding: ${smallMargin} ${gutter} 0;
      position: absolute;
      width: 100%;
      z-index: 3;

      ${minWidth(tablet)} {
        display: flex;
        justify-content: flex-start;
        flex-direction: row-reverse;
        align-items: center;
        padding: ${mediumMargin} calc(${gutter} * 2) 0;
      }
    `}
  >
    <div
      css={`
        display: flex;
        justify-content: flex-end;
      `}
    >
      <PhoneNumberLink className={defaultLink} phoneNumber={phoneNumber} />
    </div>
    <div
      css={`
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
      `}
    >
      {posts
        .filter(
          ({ sectionType, navigation }) =>
            sectionType !== 'instagram' &&
            sectionType !== 'popup' &&
            sectionType !== 'marketing' &&
            navigation // instagram can't be in menu because if it errors it doesn't show. Menu does not keep track of instagram errors so would show a link to nowhere
        )
        .map(({ slug, heading: text }) => (
          <Link key={slug} to={slug} className={navigationLink}>
            {text}
          </Link>
        ))}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./app/components/Navigation/Navigation.js